import { FC } from 'react';

import { Box } from '@qwealth/qcore';

import BackButton from '../../../common/BackButton';
import InfoTag from 'components/common/SectionHeader/InfoTag';
import { ComplianceChecklistStatus } from 'data/models/Compliance';

interface Props {
  contactName: string | undefined;
  checklistStatus: ComplianceChecklistStatus | undefined;
  isComplianceApproved: boolean | undefined;
  clickBack: () => void;
}

const ClientNotesHistoryModalHeader: FC<Props> = ({ clickBack, contactName, checklistStatus, isComplianceApproved }): JSX.Element => {
  const isStatusAdvisorActionRequired = checklistStatus === 'Advisor Action Required';
  return (
    <Box display="flex" flexDirection="column">
      <BackButton clickBack={clickBack} hasIcon={true} btnText="Back" textSize="default" />
      <Box display="flex" flexDirection="column" alignItems="center" gap="small">
        {contactName && (
          <Box fontSize="sectionTitle" fontWeight="bold">
            {contactName}
          </Box>
        )}
        {isComplianceApproved && <InfoTag tagTitle="Compliance Approved" icon="Check Mark" />}
        {checklistStatus && !isComplianceApproved && <InfoTag tagTitle={isStatusAdvisorActionRequired ? 'Action Required' : checklistStatus} />}
      </Box>
    </Box>
  );
};

export default ClientNotesHistoryModalHeader;
